import { create } from "zustand";
import { RefProgram } from "@/types/referals";

interface CurrentRefProgramState {
  currentRefProgram: RefProgram | null;
  setCurrentRefProgram: (elem: RefProgram | null) => void;
}

export const useCurrentRefProgramStore = create<CurrentRefProgramState>()(
  (set) => ({
    currentRefProgram: null,
    setCurrentRefProgram: (elem) =>
      set(() => ({
        currentRefProgram: elem,
      })),
  })
);
